<template>
  <span
    class="flex items-center justify-center rounded-full bg-white text-teal-700"
    :class="CHIP_CLASSES[display]"
    :title="display === 'label' ? undefined : chip.label"
  >
    <component :is="icon" class="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
    <!-- Always in the DOM so icon-only chips keep an accessible name -->
    <span :class="LABEL_CLASSES[display]">{{ chip.label }}</span>
  </span>
</template>

<script setup lang="ts">
import { Accessibility, Package } from 'lucide-vue-next'
import type {
  ProductCardChipDisplay,
  ProductCardImageChip,
} from '~/utils/productCardMapper'

const { chip, display = 'label' } = defineProps<{
  chip: ProductCardImageChip
  display?: ProductCardChipDisplay
}>()

const CHIP_CLASSES: Record<ProductCardChipDisplay, string> = {
  label: 'gap-1 px-2 py-1 text-caption-small font-semibold',
  icon: 'h-7 w-7',
  responsive:
    'h-7 w-7 md:h-auto md:w-auto md:gap-1 md:px-2 md:py-1 md:text-caption-small md:font-semibold',
}

const LABEL_CLASSES: Record<ProductCardChipDisplay, string> = {
  label: '',
  icon: 'sr-only',
  responsive: 'sr-only md:not-sr-only',
}

const icon = computed(() =>
  chip.kind === 'accessible' ? Accessibility : Package
)
</script>
